export default __webpack_public_path__ + "static/media/SSC.0e028d0e.jpg";